import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FOOTER_HEIGHT } from 'src/common/constants';
import { useAppSelector } from 'src/hooks';
import { APP_URLS } from 'src/setup/client/app-urls';

const FooterStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${FOOTER_HEIGHT};
    padding: 16px 24px;
    ${({ theme: { colors, typography } }) => `
        background-color: ${colors.background.overlay.v5};
        border-top: 1px solid ${colors.border.light};
        font-size: ${typography.size.desktop.paragraph.p3};
        line-height: ${typography.lineHeight[2]};
        font-weight: ${typography.weight.light};
        background-color: ${colors.background.primary};
        & > div:last-of-type {
            color: ${colors.text.primary};
        }
    `}
`;

export const NavLink = styled.a`
    float: left;
    cursor: pointer;
    &:not(:last-of-type) {
        margin-right: 32px;
    }
    ${({ theme: { colors } }) => `
        color: ${colors.text.primary} !important;
        &:hover,
        &:focus {
            color: ${colors.text.primary};
        }
    `}
`;

const Footer: FC = () => {
    const { t } = useTranslation();
    const { copyright } = useAppSelector((state) => state.globalData.indexConfig);
    return (
        <FooterStyle>
            <div>
                <NavLink href={APP_URLS.FOOTER_URLS.MARKET}>{t('markets')}</NavLink>
                <NavLink href={APP_URLS.FOOTER_URLS.TRADING_FEE}>{t('trading_fee')}</NavLink>
                <NavLink href={APP_URLS.FOOTER_URLS.API} target={'blank'}>
                    {t('api')}
                </NavLink>
                <NavLink href={APP_URLS.FOOTER_URLS.HELP} target={'blank'}>
                    {t('help_center')}
                </NavLink>
            </div>
            <div>{copyright}</div>
        </FooterStyle>
    );
};

export { Footer };
